/*-----------------------------------------------------------------
- Comments From
-----------------------------------------------------------------*/
export default {
    message: {
        success: 'تم إرسال رسالتك بنجاح.',
        error  : 'مشكلة في التسجيل',
    },
};
